import { Button, useTheme } from '@mui/material';
import React from 'react';
import IconArrowLeft from 'shared/icons/iconArrowLeft';

export default function BackButton({ onClick }: { onClick: () => void }) {
  const theme = useTheme();

  return (
    <Button
      variant="contained"
      color="inherit"
      sx={{ borderRadius: '10px', minWidth: 0 }}
      onClick={onClick}
    >
      <IconArrowLeft extColor={theme.palette.custom.grey}></IconArrowLeft>
    </Button>
  );
}
